/**
 * @param {number} bytes 
 * @returns {number}
 */
export function bytesToKilobytes(bytes) {
  if (typeof bytes !== 'number' || bytes < 0) {
    throw new Error('Input must be a non-negative number.');
  }

  const KILOBYTE = 1024;
  const kilobytes = bytes / KILOBYTE;

  return kilobytes;
}